import Navbar from "assets/Navbar";
import useDistrictData from "hook/useDistrictData";
import useFreeAmountDelivery from "hook/useFreeAmountDelivery";
import useUpazillaData from "hook/useUpzillaData";
import { useEffect, useRef, useState } from "react";
import { BsCartXFill } from "react-icons/bs";
import { FaStore, FaTruck, FaTruckPickup } from "react-icons/fa";
import { TbCurrencyTaka } from "react-icons/tb";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import { useLocation } from "react-router-dom";
import { HiOutlineX } from "react-icons/hi";
import { clearCartItems, getCartItems, setCartItems } from "utils/cartStorage";
import "react-toastify/dist/ReactToastify.css";
import ScreenScrollToTop from "../components/ScreenScrollToTop";
import OrderShimmer from "../components/shimmer/orderShimmer";

const OrderDetails = () => {
  const { freeAmountDeliveryData } = useFreeAmountDelivery();
  const freeDeliveryAmount = freeAmountDeliveryData?.[0]?.amount || 0;

  const deliveryOptions = [
    { label: "ঢাকার ভিতর", price: 50, icon: <FaTruck /> },
    { label: "ঢাকার বাহিরে", price: 110, icon: <FaTruckPickup /> },
    { label: "দোকান থেকে সংগ্রহ", price: 0, icon: <FaStore /> },
  ];
  const [form, setForm] = useState({
    name: "",
    phone: "",
    whatsappPhone: "",
    address: "",
    district: "",
    upazilla: "",
  });
  const orderPlacedRef = useRef(false);

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(true);
  const [products, setProducts] = useState([]);
  const [selectedOption, setSelectedOption] = useState(deliveryOptions[0]);
  // const { district, loadingDistrict, errorDistrict } = useDistrictData();
  const { upazilla, loadingUpazilla, errorUpazilla } = useUpazillaData(
    form.district,
  );
  const location = useLocation();
  const previousPathRef = useRef(location.pathname);
  const hasFiredCheckout = useRef(false);
  const navigate = useNavigate();
  const purchaseFiredRef = useRef(false);
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (products.length > 0 && !hasFiredCheckout.current) {
      window.dataLayer = window.dataLayer || [];

      window.dataLayer.push({
        event: "begin_checkout",
        ecommerce: {
          currency: "BDT",
          value: subtotal,
          items: products.map((item) => ({
            item_id: item.item_id,
            item_name: item.selectedVariant?.title,
            price: item.selectedVariant?.flashPrice,
            quantity: item.quantity || 1,
          })),
        },
      });
      hasFiredCheckout.current = true;
    }
  }, [products]);

  const hasVariantFreeDelivery = products.some(
    (item) => Number(item?.selectedVariant?.freeVariantDelivery) === 1,
  );

  useEffect(() => {
    localStorage.setItem("abandonedCheckoutForm", JSON.stringify(form));
  }, [form]);

  const updateLocalStorage = (items) => {
    setCartItems(items);
  };

  const removeItem = (index) => {
    const updated = [...products];
    updated.splice(index, 1);

    setProducts(updated);
    updateLocalStorage(updated);

    if (updated.length === 0) {
      localStorage.removeItem("abandonedCheckoutForm");
    }
  };

  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      const storedItems = getCartItems();
      setProducts(storedItems);
      setLoading(false);
    }, 500);
  }, []);

  const handleChange = (option) => {
    setSelectedOption(option);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setForm({ ...form, [name]: value });
    // }
  };

  const validateForm = () => {
    const newErrors = {};
    if (!form.name.trim()) newErrors.name = "আপনার নাম লিখুন";
    if (!form.phone.trim()) newErrors.phone = "আপনার নাম্বার লিখুন";
    if (!/^01\d{9}$/.test(form.phone))
      newErrors.phone = "নাম্বার ০১ দিয়ে শুরু হতে হবে এবং ১১ ডিজিটের হতে হবে";
    if (form.whatsappPhone.trim() && !/^01\d{9}$/.test(form.whatsappPhone)) {
      newErrors.whatsappPhone =
        "নাম্বার ০১ দিয়ে শুরু হতে হবে এবং ১১ ডিজিটের হতে হবে";
    }
    if (!form.address.trim()) newErrors.address = "সম্পূর্ন ঠিকানা লিখুন";
    if (!form.district) newErrors.district = "জেলা লিখুন";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const sendAbandonedOrder = () => {
    if (orderPlacedRef.current) return;

    const savedForm = JSON.parse(
      localStorage.getItem("abandonedCheckoutForm") || "{}",
    );
    const savedProducts = getCartItems();

    if (!savedForm.name?.trim() || !savedForm.phone?.trim()) return;
    if (!savedProducts.length) return;

    const payload = {
      deliveryCharge: selectedOption.label,
      deliveryAmount: finalDeliveryPrice,
      name: savedForm.name,
      phone: savedForm.phone,
      address: savedForm.address || "Not provided",
      district: savedForm.district || "Not provided",
      upazilla: savedForm.upazilla || "Not provided",
      items: savedProducts.map((p) => ({
        id: Number(p.item_id),
        variant_id: Number(p.selectedVariant?.variant_id),
        color: String(p.selectedColor),
        size: String(p.selectedSize),
        quantity: Number(p.quantity || 1),
        price: String(p.selectedPrice),
      })),
    };

    navigator.sendBeacon(
      "https://backend.nuhababy.com/storeUserCanceledOrder",
      new Blob([JSON.stringify(payload)], { type: "application/json" }),
    );
  };

  useEffect(() => {
    if (previousPathRef.current !== location.pathname) {
      sendAbandonedOrder();
    }

    previousPathRef.current = location.pathname;
  }, [location.pathname]);

  useEffect(() => {
    const handleLeavePage = () => {
      if (orderPlacedRef.current) return;

      const savedForm = JSON.parse(
        localStorage.getItem("abandonedCheckoutForm") || "{}",
      );
      const savedProducts = getCartItems();

      if (!savedForm.name?.trim() || !savedForm.phone?.trim()) return;
      if (!savedProducts.length) return;

      const payload = {
        deliveryCharge: selectedOption.label,
        name: savedForm.name,
        phone: savedForm.phone,
        whatsappPhone: savedForm.whatsappPhone,
        address: savedForm.address || "Not provided",
        district: savedForm.district || "Not provided",
        upazilla: savedForm.upazilla || "Not provided",
        items: savedProducts.map((p) => ({
          id: Number(p.item_id),
          variant_id: Number(p.selectedVariant?.variant_id),
          color: String(p.selectedColor),
          size: String(p.selectedSize),
          quantity: Number(p.quantity || 1),
          price: String(p.selectedPrice),
        })),
      };

      navigator.sendBeacon(
        "https://backend.nuhababy.com/storeUserCanceledOrder",
        new Blob([JSON.stringify(payload)], { type: "application/json" }),
      );
    };

    window.addEventListener("beforeunload", handleLeavePage);

    return () => {
      handleLeavePage(); // route change
      window.removeEventListener("beforeunload", handleLeavePage);
    };
  }, []);

  const subtotal = products.reduce(
    (total, item) =>
      total + (item.selectedVariant?.flashPrice || 0) * (item.quantity || 1),
    0,
  );

  const deliverySubtotal = products.reduce((total, item) => {
    const weightInKg = Math.ceil((item.weight || 0) / 1000);
    const weightCost = weightInKg * 20;
    return weightCost;
  }, 0);
  const exactWeight = products.reduce((total, item) => {
    return (item.weight || 0) / 1000;
  }, 0);
  console.log("exactWeight", exactWeight);

  const isFreeDelivery =
    hasVariantFreeDelivery ||
    (freeDeliveryAmount > 0 && subtotal >= freeDeliveryAmount);

  const finalDeliveryPrice = isFreeDelivery
    ? 0
    : selectedOption.price > 0
      ? deliverySubtotal + selectedOption.price
      : 0;

  const finalDeliveryLabel = isFreeDelivery
    ? "Free Delivery"
    : selectedOption.label;

  const totalPrice = subtotal + finalDeliveryPrice;

  const handleSubmit = async () => {
    if (submitting || purchaseFiredRef.current) return;
    if (!validateForm()) return;
    setSubmitting(true);
    const utmData = JSON.parse(localStorage.getItem("nuha_utm_data"));
    // const selectedDistrict = district?.data?.find(
    //   (d) => String(d.id) === String(form.district),
    // );

    // const districtName = selectedDistrict ? selectedDistrict.bn_name : "";

    // Find the selected upazilla name from your upazilla list
    const selectedUpazilla = upazilla?.data?.find(
      (u) => u.bn_name === form.upazilla,
    );
    const upazillaName = selectedUpazilla ? selectedUpazilla.bn_name : "Test";
    const payload = {
      deliveryCharge: finalDeliveryLabel,
      deliveryAmount: finalDeliveryPrice,
      name: form.name,
      phone: form.phone,
      whatsappPhone: form.whatsappPhone,
      address: form.address,
      district: form.district,
      upazilla: upazillaName,
      utm: utmData ? utmData.utm_source : "Website",
      items: products.map((p) => ({
        id: Number(p.item_id),
        variant_id: Number(p.selectedVariant?.variant_id),
        color: String(p.selectedColor),
        size: String(p.selectedSize),
        quantity: Number(p.quantity || 1),
        price: String(p.selectedPrice),
      })),
    };

    try {
      const res = await fetch(`https://backend.nuhababy.com/order`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify(payload),
      });

      const data = await res.json();

      if (res.ok) {
        const order = data; // backend response
        console.log("order", order);
        if (!purchaseFiredRef.current) {
          purchaseFiredRef.current = true;
          window.dataLayer = window.dataLayer || [];

          window.dataLayer.push({
            event: "purchase",
            ecommerce: {
              transaction_id: String(order.same_order_id || Date.now()),
              value: Number(totalPrice),
              currency: "BDT",
              items: products.map((item) => ({
                item_id: String(item.item_id),
                item_name: item.selectedVariant?.title,
                price: Number(item.selectedVariant?.flashPrice),
                quantity: item.quantity || 1,
                item_category: item.catalogue_title,
              })),
            },
          });

          console.log("purchase event fired");
        }
        localStorage.removeItem("abandonedCheckoutForm");
        clearCartItems();
        orderPlacedRef.current = true;

        setProducts([]);
        setForm({
          name: "",
          phone: "",
          whatsappPhone: "",
          address: "",
          district: "",
          upazilla: "",
        });
        navigate(`/confirmOrder`, {
          state: {
            orderId: order.id,
            totalPrice: totalPrice,
            products: products,
          },
        });
      } else {
        toast.error("❌ অর্ডার ব্যর্থ হয়েছে।", {
          autoClose: 5000,
          closeOnClick: true,
        });
      }
    } catch (err) {
      toast.error("⚠️ নেটওয়ার্ক সমস্যার কারণে অর্ডার সম্পন্ন হয়নি।", {
        autoClose: 5000,
        closeOnClick: true,
      });
    }
  };

  return (
    <div className="flex flex-col min-h-screen ">
      <Navbar />
      {loading ? (
        <OrderShimmer />
      ) : products.length === 0 ? (
        <div className="text-center text-[#265fc9] py-10 my-5">
          <BsCartXFill className="mx-auto w-24 h-24 sm:w-40 sm:h-40 mb-5 opacity-60" />
          <h3 className="text-base sm:text-lg font-semibold mb-2 mt-5">
            কোনো পণ্য পাওয়া যায়নি
          </h3>
        </div>
      ) : (
        <>
          <div className="container mx-auto px-4 sm:px-5 mt-5">
            <div className="flex flex-col lg:flex-row gap-3">
              <div className="w-full lg:w-1/3 mb-2 border rounded-md shadow-sm p-5">
                <h2 className="lg:text-xl md:text-lg text-base font-semibold mb-2 text-[#265fc9]">
                  ডেলিভারি ঠিকানা
                </h2>
                <div className="mb-2">
                  <p className="text-sm font-bold">
                    নাম <span className="text-red-500">*</span>
                  </p>
                  <div className="flex items-center border rounded-md h-8 shadow-sm focus-within:ring-2 focus-within:ring-blue-500">
                    <input
                      type="text"
                      name="name"
                      value={form.name}
                      onChange={handleInputChange}
                      placeholder=""
                      className="w-full border-none outline-none bg-transparent text-gray-700 placeholder-gray-400"
                    />
                  </div>
                  {errors.name && (
                    <p className="text-red-500 text-xs mt-1">{errors.name}</p>
                  )}
                </div>
                <div className="mb-2">
                  <p className="text-xs font-bold">
                    নাম্বার <span className="text-red-500">*</span>
                  </p>
                  <div className="flex items-center border rounded-md h-8 shadow-sm focus-within:ring-2 focus-within:ring-blue-500">
                    <input
                      type="tel"
                      placeholder=""
                      name="phone"
                      value={form.phone}
                      onChange={handleInputChange}
                      className="w-full border-none outline-none bg-transparent text-gray-700 placeholder-gray-400 "
                    />
                  </div>
                  {errors.phone && (
                    <p className="text-red-500 text-xs mt-1">{errors.phone}</p>
                  )}
                </div>
                <div className="mb-2">
                  <p className="text-xs font-bold">
                    ঠিকানা <span className="text-red-500">*</span>
                  </p>
                  <div className="flex items-center border rounded-md h-8 shadow-sm focus-within:ring-2 focus-within:ring-blue-500">
                    <input
                      type="text"
                      placeholder=""
                      name="address"
                      value={form.address}
                      onChange={handleInputChange}
                      className="w-full border-none outline-none bg-transparent text-gray-700 placeholder-gray-400"
                    />
                  </div>
                  {errors.address && (
                    <p className="text-red-500 text-xs mt-1">
                      {errors.address}
                    </p>
                  )}
                </div>
                <div className="mb-2">
                  <p className="text-xs font-bold">
                    জেলা <span className="text-red-500">*</span>
                  </p>
                  <div className="flex items-center border rounded-md h-8 shadow-sm focus-within:ring-2 focus-within:ring-blue-500">
                    <input
                      type="text"
                      placeholder=""
                      name="district"
                      value={form.district}
                      onChange={handleInputChange}
                      className="w-full border-none outline-none bg-transparent text-gray-700 placeholder-gray-400"
                    />
                  </div>
                  {errors.district && (
                    <p className="text-red-500 text-xs mt-1">
                      {errors.district}
                    </p>
                  )}
                </div>
                {/* <div className="mb-2">
                  <p className="text-xs font-bold">
                    জেলা <span className="text-red-500">*</span>
                  </p>
                  <div className="flex items-center border rounded-md h-8 shadow-sm focus-within:ring-2 focus-within:ring-blue-500">
                    <select
                      name="district"
                      value={form.district}
                      onChange={handleInputChange}
                      className="w-full border-none outline-none bg-transparent text-gray-700"
                    >
                      <option value=""></option>
                      {loadingDistrict && <option>Loading...</option>}
                      {errorDistrict && (
                        <option>Error loading districts</option>
                      )}
                      {district?.data?.map((d) => (
                        <option key={d.id} value={d.id}>
                          {d.bn_name}
                        </option>
                      ))}
                    </select>
                  </div>
                  {errors.district && (
                    <p className="text-red-500 text-xs mt-1">
                      {errors.district}
                    </p>
                  )}
                </div> */}
                <div className="mb-2">
                  <p className="text-xs font-bold mb-1">
                    অন্যের জন্য অর্ডার করলে আপনার Whatsapp নাম্বার দিন
                  </p>
                  <div className="flex items-center border rounded-md h-8 shadow-sm focus-within:ring-2 focus-within:ring-blue-500">
                    {/* <FaSquarePhone className="text-gray-500 mr-3" /> */}
                    <input
                      type="tel"
                      placeholder=""
                      name="whatsappPhone"
                      value={form.whatsappPhone}
                      onChange={handleInputChange}
                      className="w-full border-none outline-none bg-transparent text-gray-700 placeholder-gray-400 "
                    />
                  </div>
                  {errors.whatsappPhone && (
                    <p className="text-red-500 text-xs mt-1">
                      {errors.whatsappPhone}
                    </p>
                  )}
                </div>
              </div>

              <div className="w-full lg:w-1/3 mb-1">
                <h2 className="lg:text-xl md:text-lg text-base text-[#265fc9] font-semibold ">
                  ডেলিভারি
                </h2>
                <span className=" text-xs text-gray-500">
                  (পণ্যের ওজনের উপর ডেলিভারী চার্জ নির্ভরশীল)
                </span>
                <div className="space-y-5 pt-2">
                  <div className="flex justify-between items-start mb-4">
                    <div className="flex gap-2">
                      {deliveryOptions.map((option, index) => (
                        <button
                          key={index}
                          onClick={() => handleChange(option)}
                          className={`flex items-center px-2 py-1.5 md:text-sm text-xs rounded-md border font-medium transition-all
                                      ${
                                        selectedOption.label === option.label
                                          ? "text-[#265fc9] bg-white border-[#265fc9]"
                                          : "bg-white text-gray-700 border-gray-300 hover:bg-gray-100"
                                      }`}
                        >
                          <span className="text-base px-1">{option.icon}</span>
                          {option.label}
                        </button>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
              {freeDeliveryAmount > 0 ? (
                <div className="mb-2">
                  <p className="flex items-center text-backgroundColor font-bold text-center">
                    🎁🎁 {freeDeliveryAmount} টাকার পণ্য কিনলেই পাচ্ছেন সারা
                    বাংলাদেশ ফ্রি ডেলিভারী অফার 🎁 🎁
                  </p>
                </div>
              ) : null}

              <div className="w-full lg:w-2/3 mb-2">
                <div className="p-5 mb-3 border rounded-md shadow-sm">
                  <h2 className="lg:text-xl md:text-lg text-base text-[#265fc9] font-semibold mb-2">
                    আপনার অর্ডার
                  </h2>
                  {/* Desktop Header */}
                  <div className="hidden md:grid grid-cols-5 font-semibold border-b pb-2">
                    <div className="col-span-2">পণ্য</div>
                    <div className="text-center">দাম</div>
                    <div className="text-center">পরিমান</div>
                    <div className="text-right">মোট</div>
                  </div>

                  {products.map((item, index) => (
                    <div
                      key={index}
                      className="relative flex flex-col md:grid md:grid-cols-[2fr_auto_auto_auto] gap-3 md:gap-4 items-center border-b pb-3"
                    >
                      {/* Product Info */}
                      <div className="flex gap-3 items-center w-full">
                        <div className="relative">
                          <img
                            src={`https://backend.nuhababy.com/${item.selectedVariant.images[0].thumb}`}
                            alt={item.selectedVariant?.title}
                            className="w-16 h-16 sm:w-20 sm:h-20 object-top object-cover rounded"
                          />
                          <button
                            onClick={() => removeItem(index)}
                            className="absolute top-0 left-0 bg-red-600 font-bold text-white rounded-full p-1 shadow-2xl shadow-gray-400/70 transition-all duration-200 scale-90 hover:scale-100"
                          >
                            <HiOutlineX className="w-4 h-4" />
                          </button>
                        </div>
                        <div className="flex-1">
                          <div className="text-gray-500 hidden md:flex">
                            <p className="font-semibold text-sm sm:text-base">
                              {" "}
                              {item.selectedVariant?.title}
                            </p>
                            <p className="text-xs font-bold mt-1 flex items-center">
                              {item.selectedVariant?.flashPrice}{" "}
                              <TbCurrencyTaka />
                            </p>
                            <p className="text-xs font-semibold mt-1">
                              {" "}
                              {item.quantity}
                            </p>
                          </div>
                          <div className=" text-gray-500">
                            <p className="text-xs sm:text-sm md:hidden font-semibold">
                              {" "}
                              {item.selectedVariant?.title}
                            </p>
                            <p className="text-xs font-bold mt-1 flex items-center">
                              Quantity: {item.quantity} x{" "}
                              {item.selectedVariant?.flashPrice}{" "}
                              <TbCurrencyTaka />
                            </p>
                          </div>
                        </div>
                        {/* Mobile View - Price and Quantity */}
                        <div className="md:hidden">
                          <div className="flex items-center justify-start">
                            <span className="font-bold text-sm text-[#265fc9]">
                              {(item.selectedVariant?.flashPrice || 0) *
                                (item.quantity || 1)}
                            </span>
                            <TbCurrencyTaka className="text-[#265fc9]" />
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                  <div className="mb-2 mt-3 font-extrabold flex justify-between md:text-lg text-xs ">
                    <span>মোট</span>
                    <span className="text-[#265fc9]">
                      {subtotal}
                      <TbCurrencyTaka className="inline" />
                    </span>
                  </div>
                  <div className="my-2 font-extrabold flex justify-between md:text-lg text-xs">
                    <span>
                      ডেলিভারী খরচ{" "}
                      <span className="text-gray-500">
                        {exactWeight > 0 && <>ওজনঃ {exactWeight} KG</>}
                      </span>
                    </span>
                    <span className="text-[#265fc9]">
                      {finalDeliveryPrice}
                      <TbCurrencyTaka className="inline" />
                    </span>
                  </div>
                  <div className="mt-2 mb-3 font-extrabold flex justify-between md:text-lg text-xs">
                    <span>সর্বমোট</span>
                    <span className="text-[#265fc9]">
                      {totalPrice}
                      <TbCurrencyTaka className="inline" />
                    </span>
                  </div>
                  <div className="items-center flex justify-center mt-2">
                    <button
                      type="button"
                      onClick={handleSubmit}
                      disabled={submitting}
                      className="w-full bg-[#265fc9]  text-white md:py-3 py-3 rounded-md transition-colors lg:text-base text-base"
                    >
                      <span className="text-white">🛒</span> অর্ডার করুন
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}

      <ScreenScrollToTop />

      {/* Toast Container */}
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </div>
  );
};

export default OrderDetails;
